<template>
  <div class="user-card" :style="style" ref="e" v-show="showFlag" @mouseenter="cancelClose" @mouseleave="close">
      <el-skeleton :loading="loading" animated>
        <template slot="template">
          <div class="card-wrapper">
            <div class="bg">
              <el-skeleton-item variant="image" class="img" />
            </div>
            <a class="avatar">
              <el-skeleton-item variant="image" class="img" style="width: 50px;height: 50px;"/>
            </a>
            <div class="user-info">
              <el-skeleton-item variant="text" style="width: 80%"/>
            </div>
            <div class="social">
              <el-skeleton-item variant="text" style="width: 50%"/>
            </div>
            <p class="sign">
              <el-skeleton-item variant="text"/>
            </p>
            <div class="option">
              <el-skeleton-item variant="button" style="height: 28px;"/>
              <el-skeleton-item variant="button" style="height: 28px;margin-left: 10px;"/>
            </div>
          </div>
        </template>
        <template>
          <div class="card-wrapper">
            <div class="bg">
              <el-image class="img"
                        :src="banner"
                        fit="cover"></el-image>
            </div>
            <a class="avatar">
              <el-avatar :src="user.avatar" :size="50"></el-avatar>
            </a>
            <div class="user-info">
              <span class="name">{{ name }}</span>
              <Man v-if="user.gender === 'MAN'"></Man>
              <Wom v-if="user.gender === 'WOM'"></Wom>
              <LevelIcon :level="user.level"></LevelIcon>
            </div>
            <div class="social">
              <span>共同好友：{{ user.sameFriendCount }}</span>
            </div>
            <p class="sign" :title="user.sign" v-show="user.sign">
              {{ user.sign }}
            </p>
            <p class="sign" v-show="!user.sign" style="color: #777">
              暂无签名
            </p>
            <div class="option">
              <el-button type="primary" size="mini" v-if="!user.friendly" @click="addFriend">加好友</el-button>
              <el-button type="primary" size="mini" @click="sendMsg">发消息</el-button>
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>
</template>

<script>
    import LevelIcon from "../component/LevelIcon";
    import Wom from '../icon/gender/Wom'
    import Man from '../icon/gender/Man'
    import userCardBus from '../../js/bus/userCardBus'
    import { lookElementXY } from "../../js/utils/domLocation";
    import { on, off } from '../../js/utils/dom'
    import {nextZIndex} from "../../js/utils/zIndexUtil";
    import bus from "../../js/bus/bus";
    import setting from "../../config/setting";

    export default {
        name: "UserCard",
        components: {LevelIcon, Wom, Man},
        data() {
            return {
                mineId: "",
                id: "",
                showFlag: false,
                loading: true,
                style: {},
                user: {
                    // id: '1',
                    // name: '唐志强',
                    // remarks: '会有天使替我爱你',
                    // avatar: 'https://dss2.baidu.com/6ONYsjip0QIZ8tyhnq/it/u=765132077,3950664526&fm=58',
                    // sign: '再给我两分钟，让我把记忆结成冰',
                    // gender: 'MAN',
                    // banner: 'https://fc1tn.baidu.com/it/u=860387245,3517879775&fm=202&mola=new&crop=v1',
                    // level: 4,
                    // sameFriendCount: 1,
                },
                cache: {},
                openTimeout: null,
                closeTimeout: null,
            }
        },
        created() {
            userCardBus.onShow((id, domRect) => {
                if (id === this.mineId)
                    return;
                this.cancelOpen();
                this.cancelClose();
                this.id = id;
                this._open(domRect);
            });
            userCardBus.onHide(() => {
                this.close();
            });
            this.$im.getAccountInfo(({id}) => {
                this.mineId = id;
            });
        },
        mounted(){
            this.$removeToBody();
        },
        methods: {
            load() {
                let id = this.id;
                if (this.cache[id])
                    return this.user = this.cache[id];
                this.loading = true;
                this.$im.get("/USER/v1/users/" + id + "/card", {}, true, (data) => {
                    this.cache[id] = data;
                    this.user = data;
                    this.loading = false;
                })
            },
            addFriend() {
                //添加来源: 6(空间)
                bus.$emit("addFriend", {id: this.user.id,
                    name: this.user.name,
                    avatar: this.user.avatar}, 6);
            },
            sendMsg() {
                bus.$emit("userChat", {id: this.user.id,
                    name: this.user.name,
                    avatar: this.user.avatar})
            },
            cancelOpen() {
                clearTimeout(this.openTimeout);
            },
            cancelClose() {
                clearTimeout(this.closeTimeout);
            },
            _open(domRect) {
                this.openTimeout = setTimeout(() => {
                    this.showFlag = true;
                    this.$nextTick(() => {
                        this.style = lookElementXY(domRect, this.$refs.e.getBoundingClientRect());
                        this.style['z-index'] = nextZIndex();
                        this.load();
                    });
                }, 300);
            },
            close() {
                this.cancelOpen();
                this.closeTimeout = setTimeout(() => {
                    this.showFlag = false;
                }, 300);
            },
        },
        computed: {
            name() {
                return this.user.remarks ? this.user.remarks : this.user.name;
            },
            banner() {
                return this.user.banner ? this.user.banner : setting.defaultBanner;
            }
        }
    }
</script>

<style scoped>
  .user-card {
    width: 340px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 4px;
    position: fixed;
    background-color: white;
    z-index: 2;
  }


  .bg {
    font-size: 0;
    margin-bottom: 8px;
  }

  .bg .img {
    width: 100%;
    height: 110px;
  }

  .avatar {
    position: absolute;
    border: 2px solid white;
    border-radius: 73%;
    font-size: 0;
    left: 25px;
    top: 90px;
    overflow: hidden;
  }

  .user-info, .social, .sign, .option {
    padding: 0 25px 0 85px;
    margin-bottom: 12px;
  }

  .user-info .name {
    font-weight: bolder;
  }


  .social {
    font-size: 12px;
  }

  .sign {
    font-size: 12px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/view/userCard/UserCard.vue